export default __webpack_public_path__ + "static/media/chooseyourown.6cea9258.jpg";